import PhoneInput from "react-phone-number-input";
import en from "react-phone-number-input/locale/en";
import ru from "react-phone-number-input/locale/ru";
import "react-phone-number-input/style.css";
import { color_black } from "../../../constants/colors";
import {
    OnestNormalSmall,
    OnestSemiBoldSmall,
} from "../../styled/TextComponents";
import { useI18n } from "../../../i18n/I18nProvider";

const MAX_PHONE_DIGITS = 15; // E.164, как в legacy

export const FormPhoneInput = ({
  placeholder,
  value,
  title,
  defaultValue,
  register,
  onChange,
  required = false,
  inputBackgroundColor,
  width = 350,
  titleStyle = "normal",
}) => {
  const { locale } = useI18n();
  const cssWidth = typeof width === "number" ? `${width}px` : width;

  const handleChange = (newValue) => {
    let str = newValue || "";
    const digits = str.replace(/\D/g, "");
    if (digits.length > MAX_PHONE_DIGITS) {
      str = "+" + digits.slice(0, MAX_PHONE_DIGITS);
    }
    onChange({ target: { value: str } });
  };

  return (
    <div
      className="FormPhoneInput-wrapper"
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: cssWidth,
        gap: 10,
        fontSize: 16,
      }}
    >
      {titleStyle === "semiBold" ? (
        <OnestSemiBoldSmall>{title}</OnestSemiBoldSmall>
      ) : (
        <OnestNormalSmall>{title}</OnestNormalSmall>
      )}
      <PhoneInput
        international
        defaultCountry="RU"
        countryCallingCodeEditable={false}
        limitMaxLength={true}
        value={!value || value === "+" ? "+7" : value}
        onChange={handleChange}
        labels={locale === "en" ? en : ru}
        placeholder={placeholder || undefined}
        numberInputProps={{
          ...(register || {}),
          required,
          style: {
            width: "100%",
            height: "50px",
            borderRadius: "10px",
            border: "1px solid transparent",
            backgroundColor: inputBackgroundColor || "#F5F5F5",
            outline: "none",
            fontFamily: "Onest",
            color: color_black,
            padding: "0 15px",
            fontSize: 16,
          },
        }}
        className="FormPhoneInput"
      />
      <style>{`
        .FormPhoneInput-wrapper {
          --PhoneInput-color--focus: #F04F4F;
          --PhoneInputCountrySelect-marginRight: 0.2em;
        }
        .FormPhoneInput-wrapper .PhoneInput {
          width: ${cssWidth} !important;
          min-width: ${cssWidth} !important;
          max-width: ${cssWidth} !important;
          box-sizing: border-box;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid transparent;
          background-color: ${inputBackgroundColor || "#F5F5F5"};
          padding: 0 0 0 10px;
        }
        .FormPhoneInput-wrapper .PhoneInputInput {
          border: none !important;
          background: transparent !important;
          height: 50px;
          min-width: 0;
          flex: 1;
        }
        .FormPhoneInput-wrapper .PhoneInputCountry {
          margin: 0 6px 0 0;
          padding: 0;
          flex-shrink: 0;
        }
      `}</style>
    </div>
  );
};
